/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponse } from 'app/shared/models';
import { BaseService } from 'app/shared/services';
import { catchError, of } from 'rxjs';

import { Injectable } from '@angular/core';
import { SnackbarType } from '@fuse/services/snackbar';
import { translate } from '@jsverse/transloco';

@Injectable({ providedIn: 'root' })
export class FleetsIssuesService extends BaseService {
  private readonly _endPoint = '/fleet-issues';

  constructor() {
    super();
  }

  getIssuesByLocation(
    locationId?: string | null,
    partnerId?: string | null
  ) {
    return this.clientService
      .get<ApiResponse<any[]>>(
        `${this._endPoint}/location/${locationId ?? 'undefined'}`,
        partnerId ? { partnerId } : {}
      )
      .pipe(
        catchError(() => {
          this.showMessage(
            SnackbarType.Error,
            translate('messages.get_all_error')
          );

          return of({ data: [] } as ApiResponse<any[]>);
        })
      );
  }

  deleteIssue(issueId: string) {
    return this.clientService
      .delete<ApiResponse<null>>(`${this._endPoint}/${issueId}`)
      .pipe(
        catchError(({ success, error }) => {
          this.showMessage(
            SnackbarType.Error,
            translate('messages.delete_error')
          );

          return of(new ApiResponse<null>(success, null, error));
        })
      );
  }
}
